module.exports = __webpack_public_path__ + "img/art1.b60612c3.svg";